<template>
  <div id="introduce-guideline">
    <section id="TổngQuan">
      <h4>Tổng Quan Màn Hình Danh Sách Content</h4>
      <p>
        Màn hình chứa danh sách phim (content) được chia làm 2 loại là
        <span class="highlight-text">
          single (phim lẻ) và season (phim bộ).</span
        >
        <br />
        Ở màn hình này user có thể
        <span class="highlight-text">tìm kiếm </span> theo tên của
        <span class="highlight-text">content / season</span>
        <br />
        Chọn 1 content hoặc 1 season bất kì để vào màn hình
        <span class="highlight-text">details content</span>
      </p>
      <img src="../../assets/tutorial/screen-list-content.png" />
    </section>
  </div>
</template>

<script>
import { call, sync } from "vuex-pathify";
import { mdiPlus } from "@mdi/js";
export default {
  data() {
    return {
      mdiPlus: mdiPlus,
    };
  },

  mounted() {
    let items = document.getElementById("introduce-guideline")?.childNodes;
    if (items) {
      let ids = Array.prototype.reduce.call(
        items,
        function (arr, elem) {
          arr.push(elem.id);
          return arr;
        },
        []
      );
      this.setListTitle([...ids]);
    }
  },

  computed: {
    myAnchorTilte: sync("showcase/myAnchorTilte"),
  },
  methods: {
    setListTitle: call("showcase/setListTitle"),
  },
};
</script>

<style></style>
